import { Component } from '@angular/core';

@Component({
  templateUrl: './switch.html'  
})
export class SwitchComponent { 
    constructor() { }
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/switch/switch-component.ts